import React from 'react';
import { Tabs } from 'expo-router';
import type { ColorValue } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useAlerts } from '../../src/data';
import { TabAlerts, TabConditions, TabHome, TabMe, TabSearch } from '../../src/TabIcons';
import { D } from '../../src/theme';

/** 선택 상태를 색이 아니라 채움으로 구분한다. 작은 크기에서는 색만으로 안 읽힌다. */
function icon(Cmp: React.ComponentType<{ color: string; focused: boolean }>) {
  return ({ color, focused }: { color: ColorValue; focused: boolean }) => <Cmp color={String(color)} focused={focused} />;
}

export default function TabLayout() {
  const unread = useAlerts().filter((a) => !a.read).length;
  // 안드로이드 제스처 바·아이폰 홈 인디케이터가 탭을 가리지 않도록 안전영역만큼 띄운다
  const bottom = useSafeAreaInsets().bottom;
  return (
    <Tabs
      screenOptions={{
        headerShown: false,
        sceneStyle: { backgroundColor: D.ground },
        tabBarActiveTintColor: D.ink,
        tabBarInactiveTintColor: D.ink3,
        // 탭바도 같은 문법 — 흰 판에 검은 선, 각진 모서리
        // 아이콘 24 + 라벨 한 줄이 들어갈 높이. 60 이면 한글 라벨 아랫부분이 잘린다
        // (제스처 바가 없는 기기·웹에서 bottom=0 이라 여유가 없다)
        tabBarStyle: { backgroundColor: D.panel, borderTopColor: D.ink, borderTopWidth: 1, height: 68 + bottom, paddingTop: 7, paddingBottom: bottom + 8 },
        tabBarLabelStyle: { fontSize: 10.5, fontWeight: '600', lineHeight: 14, includeFontPadding: false },
      }}
    >
      <Tabs.Screen name="index" options={{ title: '홈', tabBarIcon: icon(TabHome) }} />
      <Tabs.Screen name="search" options={{ title: 'AI 검색', tabBarIcon: icon(TabSearch) }} />
      <Tabs.Screen
        name="alerts"
        options={{
          title: '알림',
          tabBarIcon: icon(TabAlerts),
          tabBarBadge: unread || undefined,
          tabBarBadgeStyle: { backgroundColor: D.alert, color: '#FFFFFF', fontSize: 10 },
        }}
      />
      <Tabs.Screen name="conditions" options={{ title: '내 조건', tabBarIcon: icon(TabConditions) }} />
      <Tabs.Screen name="me" options={{ title: '내 정보', tabBarIcon: icon(TabMe) }} />
    </Tabs>
  );
}
